<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="addHandle">新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="pic" slot-scope="text, record">
        <img
          style="width: 68px ; height: 68px; float: left"
          :src="record.pic_url"
        />
      </span>
      <span slot="price" slot-scope="text, record">
        <div>{{ record.price / 100 }}</div>
      </span>
      <span slot="rank" slot-scope="text, record">
        <template>
          <editable-cell
            :text="text"
            @change="onRankChange(record.id, 'rank', $event)"
          />
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="删除后不可恢复,确定删除吗?"
            @confirm="deleteHandle(record)"
            okText="确定"
            cancelText="取消"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
      :maskClosable="false"
      title="操作"
      :width="1200"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="名称"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'title',
                    { rules: [{ required: true, message: '请输入名称' }] },
                  ]"
                  placeholder="请输入名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="价格"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'price',
                    { rules: [{ required: true, message: '请输入价格' }] },
                  ]"
                  placeholder="请输入价格"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="投票次数"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'vote_count',
                    { rules: [{ required: true, message: '请输入投票次数' }] },
                  ]"
                  placeholder="请输入投票次数"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图片上传"
                hasFeedback
              >
                <pic-uploader :file-list="formData.pic" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="限购次数"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'limit_count',
                    { rules: [{ required: true, message: '请输入限购次数' }] },
                  ]"
                  placeholder="请输入限购次数"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import areaOptions from "@/utils/area";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

import {
  getvoteGoodsList,
  setGoodsRank,
  addGoods,
  editGoods,
  deleteGoods,
  getGoodsDetail,
} from "@/api/vote";
export default {
  name: "KaojiApplyList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      saveLoading: false,
      formData: {
        id: 0,
        status: 1,
        title: "",
        activity_id: "",
        pic: [],
        limit_count:0
      },
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "名称",
          dataIndex: "title",
          scopedSlots: { customRender: "title" },
        },
        {
          title: "图片",
          dataIndex: "pic",
          scopedSlots: { customRender: "pic" },
        },
        {
          title: "价格",
          dataIndex: "price",
          scopedSlots: { customRender: "price" },
        },
        {
          title: "排序",
          dataIndex: "rank",
          scopedSlots: { customRender: "rank" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      userPagination: {
        pageSize: 30,
        p: 1,
        showTotal: (total) => {
          return "总计" + total + "条";
        },
      },
      userQuery: {
        exame_id: 0,
        status: 0,
        page: 1,
        keywords: undefined,
      },
      exameUserList: [],

      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getvoteGoodsList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
    };
  },
  computed: {},
  created() {},

  mounted() {
    let that = this;
  },
  methods: {
    moment,
    addHandle() {
      (this.formData = {
        id: 0,
        status: 1,
        title: "",
        activity_id: "",
        pic: [],
        limit_count:0
      }),
        this.form.resetFields();
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    handleEdit(record) {
      let self = this;
      this.visible = true;
      getGoodsDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },
    deleteHandle(record) {
      let self = this;
      deleteGoods({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true;
          if (self.formData.id > 0) {
            editGoods({
              id: self.formData.id,
              title: values.title,
              price: values.price,
              vote_count: values.vote_count,
              pic: self.formData.pic,
              limit_count:values.limit_count
            })
              .then((res) => {
                self.$message.success("修改成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addGoods({
              title: values.title,
              price: values.price,
              vote_count: values.vote_count,
              pic: self.formData.pic,
              limit_count:values.limit_count
            })
              .then((res) => {
                self.$message.success("修改成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setGoodsRank({
        id: key,
        rank: value,
      })
        .then((res) => {
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
  },
  filters: {},
  watch: {},
};
</script>

<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
